/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from "react";
import { getEvents } from "../services/firebase";

function useEvents() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const unsubscribe = getEvents(setEvents);
    return () => {
      unsubscribe();
    };
  }, []);

  return events;
}

export { useEvents };
